import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { convexQuery } from '@convex-dev/react-query'
import { api } from 'convex/_generated/api'
import { LoadingScreen } from '@/components/common/LoadingScreen'
import { QueuePage } from '@/features/queue/components/QueuePage'
import { useQueueDataSuspense } from '@/features/queue/hooks/useQueueData'

export const Route = createFileRoute('/_authed/queue')({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(
      convexQuery(api.setupQueue.getPendingItems, {})
    )
  },
  pendingComponent: () => <LoadingScreen message="Loading queue..." />,
  component: QueueRouteWrapper,
})

function QueueRouteContent() {
  const { queueItems } = useQueueDataSuspense()
  return <QueuePage queueItems={queueItems} />
}

function QueueRouteWrapper() {
  return (
    <Suspense fallback={<LoadingScreen message="Loading queue..." />}>
      <QueueRouteContent />
    </Suspense>
  )
}
